import React from "react";
import hpi from "../Images/Home_page_new.jpg.webp";
import sky from "../Images/sky_img.webp";
// import sahaj from "../Images/sahaj.gif";
import skykids from "../Images/skykids.webp";
import ssyoga from "../Images/ssyoga.gif";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import GoogleIcon from "@mui/icons-material/Google";
import { useState } from "react";
import "../styles/skstyles.css";
import emailjs from "@emailjs/browser";
import { withStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarBorder from "@mui/icons-material/StarBorder";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ReactPlayer from "react-player";
import srisrivideo from "../videos/newvideo.mp4";
import WeeklySessions from "../component/WeeklySessions";
import { Container } from "@mui/material";
import { Slide } from "react-slideshow-image";
import img1 from "../Images/Testimonials/1.jpg";
import img2 from "../Images/Testimonials/4.jpg";
import img3 from "../Images/Testimonials/6.jpg";
import img4 from "../Images/Testimonials/8.jpg";
import img5 from "../Images/Testimonials/10.jpg";
import img6 from "../Images/Testimonials/11.jpg";
import img7 from "../Images/Testimonials/12.jpg";
import img8 from "../Images/Testimonials/14.jpg";
import img9 from "../Images/Testimonials/16.jpg";
import img10 from "../Images/Testimonials/18.jpg";
import img11 from "../Images/Testimonials/20.jpg";
import img12 from "../Images/Testimonials/21.jpg";
import img13 from "../Images/Testimonials/23.jpg";
import img14 from "../Images/Testimonials/25.jpg";
import img15 from "../Images/Testimonials/26.jpg";
import img16 from "../Images/Testimonials/28.jpg";
import img17 from "../Images/Testimonials/30.jpg";
import img18 from "../Images/Testimonials/32.jpg";
import img19 from "../Images/Testimonials/34.jpg";
import img20 from "../Images/Testimonials/36.jpg";
import img21 from "../Images/Testimonials/38.jpg";
import img22 from "../Images/Testimonials/40.jpg";
import img23 from "../Images/Testimonials/42.jpg";
import img24 from "../Images/Testimonials/44.jpg";
import img25 from "../Images/Testimonials/46.jpg";
import grouppic from "../Images/GroupPic.jpeg";
import "../styles/slider.css";
import calmImg from "../Images/calm2.jpg";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "black",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "black",
      },
      "&:hover fieldset": {
        borderColor: "black",
      },
      "&.Mui-focused fieldset": {
        borderColor: "green",
      },
    },
  },
})(TextField);

function Home() {
  const [name, setname] = useState("");
  const [phone, setphone] = useState("");
  const [email, setemail] = useState("");
  const [message, setmessage] = useState("");
  const [inquiryType, setInquiryType] = useState("Personal enquiry");
  const [submission, setSubmission] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmission("sending");
    try {
      await emailjs.send(
        "service_pqy2g99",
        "template_2rs9mxv",
        {
          from_name: name,
          reply_to: email,
          phone_no: phone,
          inquiry_type: inquiryType,
          message_html: `Enquiry type: ${inquiryType}\n\n${message}`,
        },
        "CtSb0VbLc3M2rysQK"
      );
      setname("");
      setemail("");
      setphone("");
      setmessage("");
      setInquiryType("Personal enquiry");
      setSubmission("success");
      setTimeout(() => setSubmission("idle"), 4000);
    } catch {
      setSubmission("error");
    }
  };

  const slideImages = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
    img23,
    img24,
    img25,
  ];

  const properties = {
    duration: 5000,
    autoplay: true,
    indicators: true,
  };

  return (
    <div>
      <section className="home-intro">
        <div className="home-intro__content">
          <p className="home-eyebrow">ABOUT THE TEACHER</p>
          <h2>Sowmya Kadaveru</h2>
          <p>
            Sowmya is a Yoga and SKY Breath Meditation teacher for all ages. She
            has practiced yoga and meditation since 2011 and has taught
            transformational programs since 2015. A speech-language
            pathologist by profession, she is a 500-hour certified yoga
            instructor, with additional training in prenatal and children’s
            yoga.
          </p>
        </div>
      </section>
      <section
        className="home-hero"
        aria-labelledby="home-hero-title"
        style={{ backgroundImage: `url(${hpi})` }}
      >
        <div className="home-hero__content">
          <h1 id="home-hero-title">Manage stress and anxiety in a healthier way</h1>
          <ul className="home-hero__benefits">
            <li>
              <CheckCircleIcon aria-hidden="true" />
              <span>Relax your mind with guided breathing practices</span>
            </li>
            <li>
              <CheckCircleIcon aria-hidden="true" />
              <span>Experience meditation in a welcoming setting</span>
            </li>
            <li>
              <CheckCircleIcon aria-hidden="true" />
              <span>Learn practical techniques to manage your mind</span>
            </li>
          </ul>
          <Chip
            className="home-hero__cta"
            label="Sign up for a free online session"
            component="a"
            color="primary"
            href="https://www.eventbrite.com/e/beyond-breath-introduction-to-sky-breath-meditation-program-online-tickets-144276124773"
            target="_blank"
            rel="noreferrer"
            clickable
          />
        </div>
      </section>
      <WeeklySessions />
      <section className="home-programs">
        <h2 className="home-section-title">Explore our programs</h2>
        <div className="home-programs__grid">
          <Grid
            container
            className="home-programs__cards"
            spacing={{ xs: 2, sm: 3 }}
            columns={{ xs: 1, sm: 2, md: 3 }}
            style={{ paddingBottom: "20px" }}
          >
            <Grid className="home-programs__item" item xs={1}>
              <Card className="home-program-card">
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="300"
                    image={sky}
                    alt="Adult yoga and meditation program"
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      sx={{ textAlign: "center" }}
                      style={{
                        fontSize: "1.25rem",
                        color: "#007FCE",
                      }}
                    >
                      <b>ART OF LIVING </b> <br />
                      Adult Programs
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      style={{
                        fontSize: "1rem",
                        color: "#007FCE",
                      }}
                    >
                      Discover Gurudev Sri Sri Ravi Shankar's <br />
                      <b>ancient secret to modern well-being</b>
                      <br />
                      <br />
                    </Typography>
                    <div>
                      <Typography style={{ wordWrap: "break-word" }}>
                        <CheckCircleIcon
                          style={{ verticalAlign: "bottom", color: "#FF7E00" }}
                        />
                        Reduce stress, anxiety, and depression
                      </Typography>
                      <br />
                      <Typography style={{ wordWrap: "break-word" }}>
                        <CheckCircleIcon
                          style={{ verticalAlign: "bottom", color: "#FF7E00" }}
                        />
                        Increase your energy levels
                      </Typography>
                      <br />
                      <Typography style={{ wordWrap: "break-word" }}>
                        <CheckCircleIcon
                          style={{ verticalAlign: "bottom", color: "#FF7E00" }}
                        />
                        Improve your sleep
                      </Typography>
                      <br />
                    </div>
                    <Typography
                      variant="body2"
                      color="GrayText"
                      style={{
                        fontSize: "1rem",
                        color: "#007FCE",
                      }}
                    >
                      What's included
                    </Typography>
                    <div>
                      <List component="div" disablePadding>
                        <ListItemButton sx={{ pl: 2 }}>
                          <ListItemIcon>
                            <StarBorder
                              style={{
                                color: "#007FCE",
                              }}
                            ></StarBorder>
                          </ListItemIcon>
                          <ListItemText primary="Daily guided  energying yoga and meditation" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 2 }}>
                          <ListItemIcon>
                            <StarBorder
                              style={{
                                color: "#007FCE",
                              }}
                            ></StarBorder>
                          </ListItemIcon>
                          <ListItemText primary="Pranayama" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 2 }}>
                          <ListItemIcon>
                            <StarBorder
                              style={{
                                color: "#007FCE",
                              }}
                            ></StarBorder>
                          </ListItemIcon>
                          <ListItemText primary="SKY Breath Meditation" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 2 }}>
                          <ListItemIcon>
                            <StarBorder
                              style={{
                                color: "#007FCE",
                              }}
                            ></StarBorder>
                          </ListItemIcon>
                          <ListItemText primary="5 Keys to Joyful life" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 2 }}>
                          <ListItemIcon>
                            <StarBorder
                              style={{
                                color: "#007FCE",
                              }}
                            ></StarBorder>
                          </ListItemIcon>
                          <ListItemText primary="Life time access" />
                        </ListItemButton>
                      </List>
                    </div>
                    <Typography className="home-program-card__cta" component="div">
                      <div aria-disabled="false" className="centered">
                        <Stack direction="row" spacing={1}>
                          <Chip
                            label="Sign Up"
                            component="a"
                            color="primary"
                            href="https://linktr.ee/artoflivinglondon"
                            target="_blank"
                            clickable
                          />
                        </Stack>
                      </div>
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            {/* <Grid item xs={1} sm={4} md={4}>
            <Card sx={{ maxWidth: 345 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="300"
                  image={sahaj}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="span">
                    SAHAJ SAMADHI
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Sahaj means effortless. Samadhi means a state of true
                    meditation. Simply put, Sahaj Samadhi is an effective,
                    personalized way to easily enter into a deep meditative
                    state. Using the power of ancient sound, or mantra, you
                    can effortlessly cut through mental chatter and connect
                    with a state of deep rest and relaxation
                  </Typography>
                  <Typography>
                    <div aria-disabled="false" className="centered">
                      <Stack direction="row" spacing={1}>
                        <Chip
                          label="Sign Up"
                          component="a"
                          color="primary"
                          href="https://members.us.artofliving.org/us-en/course?courseTypeFilter=%7B%22name%22%3A%22Sahaj%20Samadhi%20Meditation%22%2C%22value%22%3A%22999649%22%7D&instructorFilter=%7B%22value%22%3A%220014600001XcEafAAF%22%2C%22label%22%3A%22JP%20Samala%22%7D"
                          target="_blank"
                          clickable
                        />
                      </Stack>
                    </div>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid> */}
            <Grid className="home-programs__item" item xs={1}>
              <Card className="home-program-card">
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="300"
                    image={skykids}
                    alt="Children practicing yoga and meditation"
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      align="center"
                      style={{
                        fontSize: "1.25rem",
                        color: "#007FCE",
                      }}
                    >
                      <b>Kids and Teens</b> <br /> Yoga and Meditation
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      component="div"
                      style={{
                        fontSize: "1rem",
                        color: "#007FCE",
                      }}
                    >
                      We offer different programs from the age 5-17 years
                      <br />
                      <br />
                      <b>Children learn tools and skills to:</b>
                      <div>
                        <br />
                        <Typography style={{ wordWrap: "break-word" }}>
                          <CheckCircleIcon
                            style={{
                              verticalAlign: "bottom",
                              color: "#FF7E00",
                            }}
                          />
                          Release stress and negative emotion
                        </Typography>
                        <br />
                        <Typography style={{ wordWrap: "break-word" }}>
                          <CheckCircleIcon
                            style={{
                              verticalAlign: "bottom",
                              color: "#FF7E00",
                            }}
                          />
                          Boost concentration and memory
                        </Typography>
                        <br />
                        <Typography style={{ wordWrap: "break-word" }}>
                          <CheckCircleIcon
                            style={{
                              verticalAlign: "bottom",
                              color: "#FF7E00",
                            }}
                          />
                          Build self-confidence
                        </Typography>
                        <br />
                        <Typography style={{ wordWrap: "break-word" }}>
                          <CheckCircleIcon
                            style={{
                              verticalAlign: "bottom",
                              color: "#FF7E00",
                            }}
                          />
                          Handle peer pressure and bullying
                        </Typography>
                        <br />
                        <Typography style={{ wordWrap: "break-word" }}>
                          <CheckCircleIcon
                            style={{
                              verticalAlign: "bottom",
                              color: "#FF7E00",
                            }}
                          />
                          Strengthen human values and social skills
                        </Typography>
                        <br />
                      </div>
                    </Typography>
                    <Typography className="home-program-card__cta" component="div">
                      <div aria-disabled="false" className="centered">
                        <Stack direction="row" spacing={1}>
                          <Chip
                            label="Sign Up"
                            component="a"
                            color="primary"
                            href="https://linktr.ee/artoflivingyouth"
                            target="_blank"
                            clickable
                          />
                        </Stack>
                      </div>
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            {/*  <Grid item xs={1}>
            <Card sx={{ maxWidth: 345 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="300"
                  image={skyteens}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="span">
                    SKY TEENS 13-17 YR OLDS
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    The SKY Teens programs helps students discover greater
                    self-confidence, resilience and a set of tools that will
                    carry them through all of life’s ups and downs. Through
                    meditation, breathing techniques and interactive
                    processes...
                    <br />
                    <br />
                  </Typography>
                  <Typography>
                    <div aria-disabled="false" className="centered">
                      <Stack direction="row" spacing={1}>
                        <Chip
                          label="Sign Up"
                          component="a"
                          color="primary"
                          href="https://linktr.ee/happyteens"
                          target="_blank"
                          clickable
                        />
                      </Stack>
                    </div>
                  </Typography>
                </CardContent> 
              </CardActionArea>
            </Card>
          </Grid>*/}
            <Grid className="home-programs__item" item xs={1}>
              <Card className="home-program-card">
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="300"
                    image={ssyoga}
                    alt="Sri Sri Yoga class"
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      align="center"
                      style={{
                        fontSize: "1.25rem",
                        color: "#007FCE",
                      }}
                    >
                      <b>Daily SRI SRI YOGA</b> Breathing and Meditation Classes
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      style={{
                        fontSize: "1rem",
                        color: "#007FCE",
                      }}
                    >
                      Sri Sri Yoga is a beautiful practice which blends
                      chanting, energizing breathing exercises (to optimize
                      functioning of respiratory channels), gentle joint
                      exercises, yoga postures, and meditation
                      <br />
                      <br />
                    </Typography>
                    <Typography className="home-program-card__cta" component="div">
                      <div aria-disabled="false" className="centered">
                        <Stack direction="row" spacing={1}>
                          <Chip
                            label="Contact @ 226-582-6067"
                            component="a"
                            color="primary"
                          />
                        </Stack>
                      </div>
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className="home-quote">
        <Grid container spacing={1}>
          <Grid item lg={4}>
            <div className="player-wrapper">
              <ReactPlayer
                className="react-player"
                url={srisrivideo}
                width="100%"
                height="100%"
                controls={true}
              />
            </div>
          </Grid>
          <Grid item lg={8} sm container>
            <Grid item xs container direction="column">
              <Grid item xs>
                <Typography gutterBottom variant="subtitle1" component="div">
                  "The Art of Living is more of a principle, a philosophy of
                  living life to its fullest. It is more a movement than an
                  organization. Its core value is to find peace within oneself
                  and to unite people in our society – of different cultures,
                  traditions, religions, nationalities; and thus reminding us
                  all that we have one goal to uplift human life everywhere."
                </Typography>
                <Typography variant="body2" gutterBottom></Typography>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>
                  Sri Sri Ravishankar - Founder and Spiritual Leader
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </section>
      <div
        className="home-testimonials"
        id="testimonials-section"
      >
        <div className="slide-container">
          <Slide {...properties}>
            {slideImages.map((slideImage, index) => (
              <div className="each-slide" key={index}>
                <img alt="e1" src={slideImage} width={"100%"} height={"600"} />
              </div>
            ))}
          </Slide>
        </div>
        <div>
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12} sm container>
                <Grid item xs container direction="column" spacing={2}>
                  <Grid item xs>
                    <Typography
                      gutterBottom
                      variant="h4"
                      component="div"
                      align="center"
                      style={{
                        fontSize: "clamp(1.5rem, 3vw, 2.5rem)",
                        color: "#007FCE",
                      }}
                    >
                      <b>What her students say about her?</b> <br />
                    </Typography>
                    <Typography variant="body2" gutterBottom></Typography>
                    <div className="testimonial-actions">
                      <Button
                        variant="outlined"
                        component="a"
                        href="https://tiny.cc/aol-map"
                        target="_blank"
                        rel="noopener noreferrer"
                        startIcon={<GoogleIcon />}
                      >
                        Read or leave a Google review
                      </Button>
                      <Button
                        variant="text"
                        component="a"
                        href="https://linktr.ee/video.testimonials"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Watch video testimonials
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </div>
      </div>
      <div>
        <div
          style={{
            paddingBottom: "25px",
            fontSize: "1rem",
            backgroundImage: `url(${calmImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            Yoga Fest 2025 for International Day of Yoga
          </div>
          <br />
          Yoga Fest 2025, led by Sowmya Kadaveru, brought together over 250
          community members to celebrate the International Day of Yoga through
          yoga, breathwork, and meditation. This vibrant, well-organized event
          reflected Sowmya’s vision of promoting well-being, mindfulness, and
          unity. With the support of dedicated volunteers, it became a day of
          deep connection and inspiration. <br></br>A special highlight was the
          SKY Kids, who led Sun Salutations on stage and shared beautiful yogic
          wisdom—a true testament to the impact of Sowmya’s programs.
        </div>
        <img alt="e1" src={grouppic} width={"100%"} />
      </div>
      <section className="contact-section" id="contact-section">
        <div className="contact-section__inner">
          <div className="contact-section__info">
            <p className="home-eyebrow">PERSONAL · GROUP · COMMUNITY</p>
            <h1>Let’s find the right session for you.</h1>
            <p className="contact-section__lead">
              Have a question about a program, or hoping to bring yoga and
              meditation to a group? Reach out and we’ll help you take the next
              step.
            </p>

            <article className="contact-group-card">
              <span className="contact-group-card__tag">For groups and organizations</span>
              <h2>Bring a session to your group</h2>
              <p>
                Sowmya has extensive experience leading group sessions. She
                welcomes enquiries from community groups, organizations, and
                teams interested in a session shaped around their needs. Share
                your group size, location, and preferred timing to start a
                conversation.
              </p>
              <a href="#contact-form" className="contact-group-card__link">
                Tell us about your group <span aria-hidden="true">→</span>
              </a>
            </article>

            <div className="contact-methods" aria-label="Direct contact options">
              <a href="mailto:sowmya.kadaveru@artofliving.org">
                <span>Email</span>
                sowmya.kadaveru@artofliving.org
              </a>
              <a href="tel:+12265826067">
                <span>Call</span>
                226-582-6067
              </a>
              <a
                href="https://wa.me/12265826067"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>WhatsApp</span>
                Send a message
              </a>
            </div>
          </div>

          <div className="contact-form-card" id="contact-form">
            <h2>Send an enquiry</h2>
            <p>Tell us a little about what you’re looking for.</p>
            <Box
              className="contact-form"
              component="form"
              onSubmit={handleSubmit}
              autoComplete="on"
            >
              <CssTextField
                id="contact-name"
                name="name"
                label="Your name"
                type="text"
                autoComplete="name"
                required
                variant="outlined"
                onChange={(e) => setname(e.target.value)}
                value={name}
                fullWidth
              />
              <CssTextField
                id="contact-email"
                name="email"
                label="Email address"
                type="email"
                autoComplete="email"
                required
                variant="outlined"
                onChange={(e) => setemail(e.target.value)}
                value={email}
                fullWidth
              />
              <CssTextField
                id="contact-phone"
                name="phone"
                label="Phone number (optional)"
                type="tel"
                autoComplete="tel"
                variant="outlined"
                onChange={(e) => setphone(e.target.value)}
                value={phone}
                fullWidth
              />
              <CssTextField
                id="contact-inquiry-type"
                name="inquiry_type"
                select
                label="What can we help with?"
                value={inquiryType}
                onChange={(e) => setInquiryType(e.target.value)}
                fullWidth
              >
                <MenuItem value="Personal enquiry">Personal enquiry</MenuItem>
                <MenuItem value="Group session">Group session</MenuItem>
                <MenuItem value="Organization enquiry">
                  Organization enquiry
                </MenuItem>
                <MenuItem value="Other">Something else</MenuItem>
              </CssTextField>
              <CssTextField
                id="contact-message"
                name="message"
                label="Message"
                placeholder="For group sessions, include your group size, location, and preferred dates."
                multiline
                minRows={4}
                required
                variant="outlined"
                onChange={(e) => setmessage(e.target.value)}
                value={message}
                fullWidth
              />
              {submission === "success" && (
                <p className="contact-form__success" role="status" aria-live="polite">
                  Thanks for reaching out. We’ll be in touch soon.
                </p>
              )}
              {submission === "error" && (
                <p className="contact-form__error" role="alert">
                  Your enquiry couldn’t be sent. Please email{" "}
                  <a href="mailto:sowmya.kadaveru@artofliving.org">
                    sowmya.kadaveru@artofliving.org
                  </a>
                  .
                </p>
              )}
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={submission === "sending"}
              >
                {submission === "sending" ? "Sending…" : "Send enquiry"}
              </Button>
            </Box>
          </div>
        </div>
      </section>
      <footer>
        <p style={{ fontSize: "0.9em", color: "#888" }}>
          Disclaimer: This is not an official Art of Living website. It is a
          personal project developed by a volunteer and supporter of the London
          chapter.
        </p>
      </footer>
    </div>
  );
}

export default Home;
